<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" :label-width="100">
      <FormItem label="品牌编码：" prop="brandCode">
        <span>{{form.brandCode}}</span>
      </FormItem>
      <FormItem label="品牌全称：" prop="brandFullName">
        <span>{{form.brandFullName}}</span>
      </FormItem>
      <FormItem label="品牌简称：" prop="brandShortName">
        <span>{{form.brandShortName}}</span>
      </FormItem>
      <FormItem label="品牌类型：" prop="type">
        <span>{{typeText(form.type)}}</span>
      </FormItem>
      <FormItem label="品牌图片：" prop="brandLogo">
        <span><sl-img width="150px" :src="form.brandLogo" method="1" /></span>
      </FormItem>
      <FormItem label="备注：" prop="remark">
        <span>{{form.remark}}</span>
      </FormItem>
    </Form>
    <div slot="footer" style="text-align: right; padding-top:12px;">
      <Button :loading="loading" type="primary" @click="hide()">关闭</Button>
    </div>
  </sl-side-panel>
</template>
<script>
export default {
  props: {
    typeData: Array
  },
  data() {
    return {
      form: {},
      loading: false,
      modalVisible: false,
      isDetail: false
    }
  },

  computed: {
    itemTitle() {
      return '详情'
    },
    title() {
      return '详情'
    }
  },
  watch: {},

  mounted() {
    // init
  },

  methods: {

    detail(id) {
      let self = this
      if (id) {
        this.$request.brandDetail(id).then(resp => {
          self.form = JSON.parse(JSON.stringify(resp.data))
        })
      }
    },

    show() {
      this.modalVisible = true
    },
    hide() {
      this.modalVisible = false
    },

    typeText(key) {
      let str = ''
      this.typeData.forEach(item => {
        if (String(item.value) === String(key)) {
          str = item.label
        }
      })
      return str
    }
  }
}

</script>
